const _ = require('lodash');
const $ = require('jquery');

const key = { backspace: 8, del: 46, enter: 13 };

module.exports = function (breakpointsService, pageStateService, moveFocus, $timeout, featureService, searchService, settingsService, searchMultisearchService) {
    return {
        scope: {
            searchTerm: '=searchInput',
            mfSearchActive: '=',
            lfSearchActive: '='
        },
        restrict: 'EA',
        link(scope, element) {
            let $multisearch, searchItemLimitReached, maximumItemsToSearch;

            scope.sfSetting = featureService.isEnabled(featureService.features.multisearchSf);
            scope.medLargeSetting = featureService.isEnabled(featureService.features.multisearch);
            scope.showSearchLimitError = false;

            settingsService.getSettingValue('Search', 'SearchItemLimitReached').then(function (setting) {
                searchItemLimitReached = setting;
            });

            settingsService.getSettingValue('Search', 'MaximumItemsToSearch').then(function (setting) {
                maximumItemsToSearch = setting;
            });

            scope.pageStateService = pageStateService;
            scope.breakpointsService = breakpointsService;

            scope.autoShowMultisearchLink = true;
            scope.multisearchFieldActive = false;

            function cleanUpMultisearchField() {
                // By default contenteditable adds funny stuff to the div.
                // We need to clean this up so that placeholder text will show.
                $timeout(function () {
                    if ($multisearch.text() === '') {
                        $multisearch.html('');
                    }
                }, 0, false);
            }

            function setCursor(startAtBeginning) {
                const range = document.createRange();
                const sel = window.getSelection();
                const offset = startAtBeginning ? 0 : 1;
                const startNode = $multisearch.children().last().get(0);
                range.setStart(startNode, offset);
                range.collapse(startAtBeginning ? true : false);
                sel.removeAllRanges();
                sel.addRange(range);
            }

            function createMultisearchLine(lineText) {
                const multisearchLineTemplate = document.createElement('p');
                multisearchLineTemplate.className = 'multisearch-line';
                multisearchLineTemplate.setAttribute('tabindex', '-1');
                if (lineText) {
                    multisearchLineTemplate.textContent = lineText;
                }
                return multisearchLineTemplate;
            }

            function scrollToLastSearchItem() {
                $multisearch.parent().scrollTop($multisearch.children().length * $multisearch.children().last().height());
            }

            function addNewMultisearchLine() {
                // if it's the first item, we need put the text inside a paragraph
                // and clear it from the multisearch div
                if ($multisearch.children().length === 0) {
                    const newLine = createMultisearchLine();
                    newLine.textContent = $multisearch.last().text();
                    $multisearch.text('');
                    $multisearch.append(newLine);
                }

                $multisearch.append(createMultisearchLine());
                setCursor(true);

                // scroll the new line into view
                if ($multisearch.children().length > 0) {
                    scrollToLastSearchItem();
                }
            }

            function getLastMultisearchChild() {
                if ($multisearch && $multisearch.children().length === 0) {
                    return $multisearch.last();
                }
                return $multisearch.children().last();
            }

            function handleKeydown(event) {
                const keyPressed = event.keyCode || event.which;
                switch (keyPressed) {
                case key.backspace:
                    //IE behaves differently so we have to handle backspace differently
                    if (event.target && event.target.className === 'multisearch-line' && $multisearch.children().length > 0 && event.target.innerText.length === 0) {
                        event.preventDefault();
                        $multisearch.children().last().remove();
                        setCursor(false);
                    }
                    cleanUpMultisearchField(event);
                    break;
                case key.del:
                    cleanUpMultisearchField(event);
                    break;
                case key.enter:
                    event.preventDefault();
                    if ($multisearch.text() && getLastMultisearchChild().text().length > 0) {
                        addNewMultisearchLine();
                    } else if (getLastMultisearchChild().text().length === 0) {
                        setCursor(true);
                    }
                    break;
                }
            }

            function getMultisearchItems() {
                searchMultisearchService.updateMultisearchItems().then(function (multisearchItems) {
                    if ($multisearch && multisearchItems) {
                        _.forEach(multisearchItems, function (item) {
                            const line = createMultisearchLine(item);
                            $multisearch.append(line);
                        });
                    }
                });
            }

            function addMultisearchListener() {
                return $timeout(function () {
                    $multisearch = element.find('#multisearch-textbox');
                    if ($multisearch.length > 0) {
                        getMultisearchItems();
                        $multisearch.on('keydown', handleKeydown);
                    }
                }, 0, false);
            }

            function removeMultisearchListener() {
                if ($multisearch) {
                    $multisearch.off('keydown', handleKeydown);
                }
            }

            function isMediumFormat() {
                return breakpointsService.isInMediumFormat || breakpointsService.isInMediumFormatGlobalHeader;
            }

            function isSettingAndSearchEnabled() {
                let settingEnabled;
                let searchActive = false;

                if (breakpointsService.isSmallFormat()) {
                    settingEnabled = scope.sfSetting;
                } else {
                    settingEnabled = scope.medLargeSetting;

                    if ((isMediumFormat() && scope.mfSearchActive) || scope.lfSearchActive) {
                        searchActive = true;
                    }
                }
                return settingEnabled && searchActive;
            }

            scope.onPaste = function (event) {
                // Cancel the paste and get the plaintext data
                event.preventDefault();
                const clipBoardData = event.originalEvent.clipboardData || window.clipboardData;
                let pastedText = '';
                try {
                    pastedText = clipBoardData.getData('text/plain');
                } catch (err) {
                    pastedText = clipBoardData.getData('text');
                }

                // Get the lines before and after the selection
                const selection = window.getSelection();
                let fromElem = selection.anchorNode.nodeName === '#text' ? selection.anchorNode.parentNode : selection.anchorNode;
                let fromOffset = selection.anchorOffset;
                let toElem = selection.focusNode.nodeName === '#text' ? selection.focusNode.parentNode : selection.focusNode;
                let toOffset = selection.focusOffset;

                // Ensure that the order of the from and to elements are correct
                if ($(fromElem).index() > $(toElem).index()) {
                    let temp = fromElem;
                    fromElem = toElem;
                    toElem = temp;
                    temp = fromOffset;
                    fromOffset = toOffset;
                    toOffset = temp;
                }

                // Generate the new text to paste
                const textBefore = (fromElem.innerText || fromElem.textContent).substring(0, fromOffset);
                const textAfter = (toElem.innerText || toElem.textContent).substring(toOffset);
                const textToSplit = textBefore + pastedText + textAfter;

                // Prepend in the line the user is editing then split into lines
                const linesToInsert = textToSplit.split(/\r?\n/);

                // If the user pasted into an empty box create a node to append to
                if ($multisearch.children().length === 0) {
                    // Ensure it is empty of text
                    $multisearch.text('');
                    const newLine = createMultisearchLine();
                    $multisearch.append(newLine);
                    fromElem = $multisearch.children()[0];
                    toElem = $multisearch.children()[0];
                }

                // Insert each item directly below the selected line (reverse order makes it display correctly)
                // The last element is the first element in the iteration
                let lastElem = null;
                linesToInsert.reverse().forEach(function (lineText) {
                    if (lineText === '') return;
                    const line = createMultisearchLine(lineText);
                    lastElem = lastElem || line;
                    $(toElem).after(line);
                });

                // Delete the elements the user has selected
                if (fromElem === toElem) {
                    $(toElem).remove();
                } else {
                    $(fromElem).nextUntil(toElem).remove();
                    $(fromElem).remove();
                    $(toElem).remove();
                }

                // Set the cursor to the last element in the insert list
                const range = document.createRange();
                const sel = window.getSelection();
                range.setStart(lastElem, 1);
                range.collapse(false);
                sel.removeAllRanges();
                sel.addRange(range);
            };

            scope.showMultisearchFields = function () {
                scope.multisearchFieldActive = true;
                addMultisearchListener();
                moveFocus('#multisearch-textbox');
            };

            scope.closeMultisearch = function () {
                scope.autoShowMultisearchLink = false;
                scope.multisearchFieldActive = false;
                scope.showSearchLimitError = false;
                removeMultisearchListener();
                moveFocus('#globalHeaderSearch');
            };

            scope.clearList = function () {
                if ($multisearch && $multisearch.text().length > 0) {
                    $multisearch.html('');
                }
                scope.showSearchLimitError = false;
                moveFocus('#multisearch-textbox');
            };

            scope.shouldShowWhenSearchInactive = function () {
                if (!scope.multisearchFieldActive) {
                    scope.autoShowMultisearchLink = true;
                    return false;
                } else if (isMediumFormat()) {
                    scope.autoShowMultisearchLink = true;
                    scope.multisearchFieldActive = false;
                    return false;
                }
                return true;
            };

            scope.shouldShowMultisearch = function () {
                if (!scope.mfSearchActive && !scope.lfSearchActive) {
                    return scope.shouldShowWhenSearchInactive();
                }

                if (scope.searchTerm.length > 0) {
                    scope.multisearchFieldActive = false;
                }

                return scope.autoShowMultisearchLink && isSettingAndSearchEnabled() && scope.searchTerm.length < 1;
            };

            function removeBlankLine(items, pattern) {
                for (let i = items.length; i--;) {
                    if (items[i].trim() === pattern) {
                        items.splice(i, 1);
                    }
                }
                return items;
            }

            scope.getMultisearchContent = function () {
                let multisearchItems = [];
                if ($multisearch && $multisearch.text()) {
                    const children = $multisearch.children('.multisearch-line');
                    if (children.length > 0) {
                        multisearchItems = _.map(children, function (multisearchLine) {
                            return multisearchLine.textContent;
                        });
                        multisearchItems = removeBlankLine(multisearchItems, '');
                    } else {
                        // there is text but it's not in a paragraph tag
                        multisearchItems.push($multisearch.text());
                    }
                }
                return multisearchItems;
            };

            function closeMultisearchAndFocus(focusElement) {
                scope.closeMultisearch();
                moveFocus(focusElement);
            }

            scope.validateMaxSearchItemLimit = function (itemLength) {
                if (maximumItemsToSearch > 0 && itemLength > maximumItemsToSearch) {
                    scope.currentNumberofItems = itemLength;
                    scope.searchLimitErrorMessage = searchItemLimitReached.replace('{MaximumItemsToSearch}', maximumItemsToSearch);
                    scope.showSearchLimitError = true;
                } else {
                    scope.showSearchLimitError = false;
                }
                return !scope.showSearchLimitError;
            };

            scope.findItems = function () {
                // get the content from the text box
                const items = scope.getMultisearchContent();
                if (items.length === 0) {
                    return;
                }

                if (!scope.validateMaxSearchItemLimit(items.length)) {
                    if (getLastMultisearchChild().text().length === 0) {
                        setCursor(true);
                    } else {
                        setCursor(false);
                    }
                    scrollToLastSearchItem();
                    moveFocus('#multisearch-textbox');
                    return;
                }

                // update the session value
                searchMultisearchService.updateMultisearchItems(items.join(',')).then(function (multisearchItems) {
                    const firstItem = multisearchItems[0];
                    if (firstItem.length < 1) {
                        return;
                    }

                    closeMultisearchAndFocus('#center-panel');
                    searchService.doMultisearch(firstItem, multisearchItems.join(','));
                });

            };

            scope.$on('window:resize', function () {
                scope.multisearchFieldActive = false;
                if (scope.mfSearchActive || scope.lfSearchActive) {
                    moveFocus('#globalHeaderSearch');
                }
            });

            scope.$on('login:success', function () {
                closeMultisearchAndFocus('#body-container');
            });
        },
        template: require('./search-multisearch-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/search/search-multisearch-directive.js
 **/